import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { useStoreConfiguration } from '../configuration/configuration';
import type { CountryType } from '../../types/country';
import { getCountry } from '../../api/country/country';

export type StoreCountry = {
  items?: CountryType;
};

const storeId = 'store-country';
const shouldPersist = ref<boolean>(true);

export const useStoreCountry = () => {
  const storeConfiguration = useStoreConfiguration();

  const innerStore = defineStore(storeId, {
    state: (): StoreCountry => {
      if (shouldPersist.value) {
        const storage = sessionStorage.getItem(storeId);

        if (storage) {
          return JSON.parse(storage) as StoreCountry;
        }
      }

      return {};
    },

    actions: {
      async fetchItems() {
        if (!storeConfiguration.config) {
          console.error(`${storeId} >>> error`, 'store configuration is not available');
          return;
        }

        const countryDataUrl = storeConfiguration.config.pt_countries_json.route;

        const items = await getCountry(countryDataUrl);

        if (items) {
          this.items = items;
        }

        if (shouldPersist.value) {
          this.persist();
        }
      },
      async persist() {
        sessionStorage.setItem(
          storeId,
          JSON.stringify({
            items: this.items,
          } satisfies StoreCountry),
        );
      },
    },
  });

  const store = innerStore();

  watch(
    () => storeConfiguration.config,
    () => {
      if (storeConfiguration.config && !store.items) {
        store.fetchItems();
      }
    },
    { immediate: true },
  );

  return store;
};
